<template>
  <div :class="componentClassName">
    <div class="o-push-segment-selection__attention">
      ※対象を何も選択せずに保存した場合は、全対象が選択された状態として保存されます。
    </div>

    <div class="o-push-segment-selection__row" :class="{ 'is-disabled': disabled }">
      <div class="o-push-segment-selection__cell-label">
        <span class="o-push-segment-selection__title">ログイン状態</span>
      </div>
      <div class="o-push-segment-selection__cell-content">
        <label class="o-push-segment-selection__radio-label">
          <input
            v-model="segmentInfo.loginFlag" type="radio"
            :disabled="disabled" :name="'loginFlag-' + id"
            :value="true" @change="handleLoginFlagChange" />
          <span class="o-push-segment-selection__radio-icon"></span>
          <span>ログイン</span>
        </label>
        <label class="o-push-segment-selection__radio-label">
          <input
            v-model="segmentInfo.loginFlag" type="radio"
            :disabled="disabled" :name="'loginFlag-' + id"
            :value="false" @change="handleLoginFlagChange" />
          <span class="o-push-segment-selection__radio-icon"></span>
          <span>未ログイン</span>
        </label>
      </div>
    </div>

    <div class="o-push-segment-selection__row" :class="{ 'is-disabled': isSubItemsDisabled }">
      <div class="o-push-segment-selection__cell-label">
        <span class="o-push-segment-selection__title">アカウント種別</span>
      </div>
      <div class="o-push-segment-selection__cell-content-list">
        <label class="o-push-segment-selection__checkbox-label">
          <input
            type="checkbox"
            value="all"
            :disabled="isSubItemsDisabled"
            :checked="segmentInfo.accountTypes.includes('all')"
            @change="handleSelectAll($event,'accountTypes')" />
          <span class="o-push-segment-selection__checkbox-icon"></span>
          <span>すべて選択</span>
        </label>

        <div class="o-push-segment-selection__sub-list">
          <label v-for="opt in options.accountTypes" :key="opt.value" class="o-push-segment-selection__checkbox-label">
            <input
              type="checkbox"
              :value="opt.value"
              :disabled="isSubItemsDisabled"
              :checked="segmentInfo.accountTypes.includes(opt.value)"
              @change="handleOptionChange($event, 'accountTypes', opt.value)" />
            <span class="o-push-segment-selection__checkbox-icon"></span>
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="o-push-segment-selection__row" :class="{ 'is-disabled': isSubItemsDisabled }">
      <div class="o-push-segment-selection__cell-label">
        <span class="o-push-segment-selection__title">業種</span>
      </div>
      <div class="o-push-segment-selection__cell-content-list">
        <label class="o-push-segment-selection__checkbox-label">
          <input
            type="checkbox"
            value="all"
            :disabled="isSubItemsDisabled"
            :checked="segmentInfo.industries.includes('all')"
            @change="handleSelectAll($event,'industries')" />
          <span class="o-push-segment-selection__checkbox-icon"></span>
          <span>すべて選択</span>
        </label>

        <div class="o-push-segment-selection__sub-list">
          <label
            v-for="opt in options.industries"
            :key="opt.value" class="o-push-segment-selection__checkbox-label">
            <input
              type="checkbox"
              :value="opt.value"
              :disabled="isSubItemsDisabled"
              :checked="segmentInfo.industries.includes(opt.value)"
              @change="handleOptionChange($event, 'industries', opt.value)" />
            <span class="o-push-segment-selection__checkbox-icon"></span>
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="o-push-segment-selection__row" :class="{ 'is-disabled': isSubItemsDisabled }">
      <div class="o-push-segment-selection__cell-label">
        <span class="o-push-segment-selection__title">従業員数</span>
      </div>
      <div class="o-push-segment-selection__cell-content-list">
        <label class="o-push-segment-selection__checkbox-label">
          <input
            type="checkbox"
            value="all"
            :disabled="isSubItemsDisabled"
            :checked="segmentInfo.employeeCounts.includes('all')"
            @change="handleSelectAll($event,'employeeCounts')" />
          <span class="o-push-segment-selection__checkbox-icon"></span>
          <span>すべて選択</span>
        </label>

        <div class="o-push-segment-selection__sub-list">
          <label
            v-for="opt in options.employeeCounts"
            :key="opt.value"
            class="o-push-segment-selection__checkbox-label">
            <input
              type="checkbox"
              :value="opt.value"
              :disabled="isSubItemsDisabled"
              :checked="segmentInfo.employeeCounts.includes(opt.value)"
              @change="handleOptionChange($event, 'employeeCounts', opt.value)" />
            <span class="o-push-segment-selection__checkbox-icon"></span>
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { accountTypeOptions, industryOptions, employeeCountOptions } from '@/common/pushSegmentOptions.js';

export default {
  name: 'o-push-segment-selection',
  props: {
    id: { type: String, default: 'o-push-segment-selection' },
    class: { type: String, default: '' },
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        loginFlag: true,
        accountTypes: [],
        industries: [],
        employeeCounts: [],
      })
    },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      segmentInfo: { ...this.modelValue },
      options: {
        accountTypes: accountTypeOptions,
        industries: industryOptions,
        employeeCounts: employeeCountOptions
      }
    };
  },
  computed: {
    componentClassName() {
      return `${mapModifiers('o-push-segment-selection')} ${this.class}`.trim();
    },
    isSubItemsDisabled() {
      return this.disabled || !this.segmentInfo.loginFlag;
    }
  },
  watch: {
    modelValue: {
      handler(val) {
        this.segmentInfo = { ...val };
      },
      deep: true
    }
  },
  methods: {
    handleLoginFlagChange() {
      if (this.segmentInfo.loginFlag === false) {
        this.segmentInfo.accountTypes = [];
        this.segmentInfo.industries = [];
        this.segmentInfo.employeeCounts = [];
      }
      this.emitChange();
    },
    handleSelectAll(event, field) {
      if (event.target.checked) {
        this.segmentInfo[field] = this.options[field].map(item => item.value);
        this.segmentInfo[field].push('all');
      } else {
        this.segmentInfo[field] = [];
      }
      this.emitChange();
    },
    handleOptionChange(event, field, value) {
      let currentArray = [...this.segmentInfo[field]];

      if (event.target.checked) {
        if (!currentArray.includes(value)) {
          currentArray.push(value);
        }
      } else {
        currentArray = currentArray.filter(v => v !== value);
        currentArray = currentArray.filter(v => v !== 'all');
      }

      if (currentArray.length === this.options[field].length) {
        currentArray.push('all');
      }

      this.segmentInfo[field] = currentArray;
      this.emitChange();
    },
    emitChange() {
      this.$emit('update:modelValue', this.segmentInfo);
      this.$emit('change', this.segmentInfo);
    }
  }
};
</script>
